import logo from './logo.svg'; 
import {useState,useEffect,useRef} from 'react';  
import './App.css';
import Addcomp from './addcomp.js'  
import {db} from './firebaseconfig.js';   
import Updatecomp from './updatecomp.js';
import View from './view.js';
import {doc,collection,getDocs,deleteDoc} from 'firebase/firestore';  
function App() {
     const [Notes,setNotes]=useState([]);
     const [Case,setCase]=useState('mainpage');  
     const [ptr,setpattern]=useState(''); 
     const [docname,setDocname]=useState('');  
     const [Id,SetId]=useState(-1);
     const [Note,setNote]=useState();
     const [Title,setTitle]=useState();
     const collectionref=collection(db,"Notes");
     useEffect(()=>{
         const getNotes=async()=>{
               const data=await getDocs(collectionref);  
               setNotes(data.docs.map((doc)=>{
                  return {...doc.data(),id:doc.id};  
               }));
               console.log(Notes);   
         }
         getNotes();
     },[]);  
     let Delete=async (ind,id)=>{
      let newNotes=Notes.filter((val,index)=>{  
            return (index!=ind);   
      });
      setNotes(newNotes);  
      await deleteDoc(doc(collectionref,id));  
     }
     let data=Notes.filter(({Title})=>{
              return (Title.search(ptr)!=-1);  
     });  
     if(Case=='mainpage')  
     {
  return (
    <div className="App">  
        <div className="searchdiv">  
              <input type="text" className="input" placeholder="Search Your notes by title" maxLength={30} value={ptr} onChange={(e)=>{setpattern(e.target.value)}}></input>  
         </div>
              {
                   data.map((note,ind)=>{  
                         return <div key={ind} className="notes">  
                                 <div onClick={()=>{setCase('viewpage');setTitle(note.Title);setNote(note.Note)}}>  
                                   <p className="title">{note.Title}</p>  
                                   <p className="note">{note.Note}</p>
                                 </div>  
                                   <div className="icon">  
                                        <i className="fa-solid fa-pen-to-square edit-icon" onClick={()=>{SetId(ind);setCase('updatepage');setDocname(note.id)}}></i>  
                                        <i className="fa-solid fa-trash del-icon" onClick={()=>{Delete(ind,note.id)}}></i>   
                                   </div>
                                </div>
                   })
              }  
         <button className="addbtn" onClick={()=>{setCase('addpage')}}>Add New Note</button>  
     </div> 
    );
   }
   else if(Case=='addpage')  
   {
      return (
    <div className="App">  
         <Addcomp notes={Notes} setnotes={setNotes} setcase={setCase}></Addcomp>  
    </div> 
      );
   }
   else if(Case=='updatepage')  
   {
      return (
         <div className="App">  
         <Updatecomp id={Id} notes={Notes} setnotes={setNotes} setcase={setCase} note={Notes[Id].Note} docname={docname} title={Notes[Id].Title}></Updatecomp>   
    </div>   
      );
   }
   else if(Case=='viewpage')
   {
      return (
          <View title={Title} note={Note} setcase={setCase}></View>  
      );  
   }
}

export default App;
